import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import {
  getLoansByAdminIdAndRole,
  getLoansCountByAdminIdAndRole,
} from "../../src/middleware/backend_hepler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faSpinner,
  faTimesCircle,
  faHourglassHalf,
  faDatabase,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  FaHome,
  FaUser,
  FaBusinessTime,
  FaCar,
  FaLandmark,
  FaCreditCard,
  FaShieldAlt,
} from "react-icons/fa";

const DashboardContent = () => {
  const { adminName, adminRole, adminId } = useContext(AuthContext);
  const [loans, setLoans] = useState({
    homeLoans: [],
    personalLoans: [],
    doctorLoans: [],
    businessLoans: [],
    mortgageLoans: [],
    carLoans: [],
    creditCardLoans: [],
    insuranceLoans: [],
  });

  const [homeLoans, setHomeLoans] = useState([]);
  const [personalLoans, setPersonalLoans] = useState([]);
  const [doctorLoans, setDoctorLoans] = useState([]);
  const [businessLoans, setBusinessLoans] = useState([]);
  const [mortgageLoans, setMortgageLoans] = useState([]);
  const [carLoans, setCarLoans] = useState([]);
  const [creditCardLoans, setCreditCardLoans] = useState([]);
  const [insuranceLoans, setInsuranceLoans] = useState([]);
  const [homeLoansInProgress, setHomeLoansInProgress] = useState(0);
  const [personalLoansInProgress, setPersonalLoansInProgress] = useState(0);
  const [doctorLoansInProgress, setDoctorLoansInProgress] = useState(0);
  const [businessLoansInProgress, setBusinessLoansInProgress] = useState(0);
  const [mortgageLoansInProgress, setMortgageLoansInProgress] = useState(0);
  const [carLoansInProgress, setCarLoansInProgress] = useState(0);
  const [creditCardLoansInProgress, setCreditCardLoansInProgress] = useState(0);
  const [insuranceLoansInProgress, setInsuranceLoansInProgress] = useState(0);

  const [homeLoansApproved, setHomeLoansApproved] = useState(0);
  const [personalLoansApproved, setPersonalLoansApproved] = useState(0);
  const [doctorLoansApproved, setDoctorLoansApproved] = useState(0);
  const [businessLoansApproved, setBusinessLoansApproved] = useState(0);
  const [mortgageLoansApproved, setMortgageLoansApproved] = useState(0);
  const [carLoansApproved, setCarLoansApproved] = useState(0);
  const [creditCardLoansApproved, setCreditCardLoansApproved] = useState(0);
  const [insuranceLoansApproved, setInsuranceLoansApproved] = useState(0);
  const [homeLoansRejected, setHomeLoansRejected] = useState(0);
  const [personalLoansRejected, setPersonalLoansRejected] = useState(0);
  const [doctorLoansRejected, setDoctorLoansRejected] = useState(0);
  const [businessLoansRejected, setBusinessLoansRejected] = useState(0);
  const [mortgageLoansRejected, setMortgageLoansRejected] = useState(0);
  const [carLoansRejected, setCarLoansRejected] = useState(0);
  const [creditCardLoansRejected, setCreditCardLoansRejected] = useState(0);
  const [insuranceLoansRejected, setInsuranceLoansRejected] = useState(0);
  const [homeLoansOpen, setHomeLoansOpen] = useState(0);
  const [personalLoansOpen, setPersonalLoansOpen] = useState(0);
  const [doctorLoansOpen, setDoctorLoansOpen] = useState(0);
  const [businessLoansOpen, setBusinessLoansOpen] = useState(0);
  const [mortgageLoansOpen, setMortgageLoansOpen] = useState(0);
  const [carLoansOpen, setCarLoansOpen] = useState(0);
  const [creditCardLoansOpen, setCreditCardLoansOpen] = useState(0);
  const [insuranceLoansOpen, setInsuranceLoansOpen] = useState(0);

  const [loanCounts, setLoanCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const filterLoans = (loanType) => {
    if (!Array.isArray(loanType)) {
      console.error("Expected an array, but got:", loanType);
      return [];
    }

    return loanType.filter((loan) => {
      if (adminRole === "admin") {
        return true;
      } else if (adminRole === "employee") {
        return (
          loan.created_by === adminName ||
          loan.created_id === adminName ||
          loan.assigned_to === adminName ||
          loan.created_by === adminId ||
          loan.created_id === adminId ||
          loan.assigned_to === adminId
        );
      }
      return false;
    });
  };

  const getLoanCounts = (loans) => {
    const counts = {
      pending: 0,
      open: 0,
      inProgress: 0,
      approved: 0,
      rejected: 0,
    };
    loans.forEach((loan) => {
      switch (loan.status) {
        case "Pending":
          counts.pending++;
          break;
        case "Open":
          counts.open++;
          break;
        case "In Process":
          counts.inProgress++;
          break;
        case "Approved":
          counts.approved++;
          break;
        case "Rejected":
          counts.rejected++;
          break;
        default:
          break;
      }
    });
    return counts;
  };

  useEffect(() => {
    fetchLoanCounts();
  }, []);
  const fetchLoanCounts = async () => {
    try {
      const response = await getLoansCountByAdminIdAndRole();
      const loanCounts = response || {};

      setHomeLoans(loanCounts.Pending.HomeLoan || 0);
      setPersonalLoans(loanCounts.Pending.PersonalLoan || 0);
      setDoctorLoans(loanCounts.Pending.DoctorLoan || 0);
      setBusinessLoans(loanCounts.Pending.BusinessLoan || 0);
      setMortgageLoans(loanCounts.Pending.MortgageLoan || 0);
      setCarLoans(loanCounts.Pending.CarLoan || 0);
      setCreditCardLoans(loanCounts.Pending.CreditCardLoan || 0);
      setInsuranceLoans(loanCounts.Pending.InsuranceForm || 0);

      setLoading(false);
    } catch (error) {
      setError("Error fetching loans.");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchLoanCounts = async () => {
      try {
        const response = await getLoansCountByAdminIdAndRole();
        const loanCounts = response || {};

        setHomeLoansInProgress(loanCounts["In Process"]?.HomeLoan || 0);
        setPersonalLoansInProgress(loanCounts["In Process"]?.PersonalLoan || 0);
        setDoctorLoansInProgress(loanCounts["In Process"]?.DoctorLoan || 0);
        setBusinessLoansInProgress(loanCounts["In Process"]?.BusinessLoan || 0);
        setMortgageLoansInProgress(loanCounts["In Process"]?.MortgageLoan || 0);
        setCarLoansInProgress(loanCounts["In Process"]?.CarLoan || 0);
        setCreditCardLoansInProgress(
          loanCounts["In Process"]?.CreditCardLoan || 0
        );
        setInsuranceLoansInProgress(
          loanCounts["In Process"]?.InsuranceForm || 0
        );

        setHomeLoansApproved(loanCounts.Approved?.HomeLoan || 0);
        setPersonalLoansApproved(loanCounts.Approved?.PersonalLoan || 0);
        setDoctorLoansApproved(loanCounts.Approved.DoctorLoan || 0);
        setBusinessLoansApproved(loanCounts.Approved?.BusinessLoan || 0);
        setMortgageLoansApproved(loanCounts.Approved?.MortgageLoan || 0);
        setCarLoansApproved(loanCounts.Approved?.CarLoan || 0);
        setCreditCardLoansApproved(loanCounts.Approved?.CreditCardLoan || 0);
        setInsuranceLoansApproved(loanCounts.Approved?.InsuranceForm || 0);

        setHomeLoansRejected(loanCounts.Rejected?.HomeLoan || 0);
        setPersonalLoansRejected(loanCounts.Rejected?.PersonalLoan || 0);
        setDoctorLoansRejected(loanCounts.Rejected.DoctorLoan || 0);
        setBusinessLoansRejected(loanCounts.Rejected?.BusinessLoan || 0);
        setMortgageLoansRejected(loanCounts.Rejected?.MortgageLoan || 0);
        setCarLoansRejected(loanCounts.Rejected?.CarLoan || 0);
        setCreditCardLoansRejected(loanCounts.Rejected?.CreditCardLoan || 0);
        setInsuranceLoansRejected(loanCounts.Rejected?.InsuranceForm || 0);

        setHomeLoansOpen(loanCounts.Open?.HomeLoan || 0);
        setPersonalLoansOpen(loanCounts.Open?.PersonalLoan || 0);
        setDoctorLoansOpen(loanCounts.Open.DoctorLoan || 0);
        setBusinessLoansOpen(loanCounts.Open?.BusinessLoan || 0);
        setMortgageLoansOpen(loanCounts.Open?.MortgageLoan || 0);
        setCarLoansOpen(loanCounts.Open?.CarLoan || 0);
        setCreditCardLoansOpen(loanCounts.Open?.CreditCardLoan || 0);
        setInsuranceLoansOpen(loanCounts.Open?.InsuranceForm || 0);

        setLoading(false);
      } catch (error) {
        setError("Error fetching loan counts.");
        setLoading(false);
      }
    };

    fetchLoanCounts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleButtonClick = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleOptionClick = (option) => {
    switch (option) {
      case "Home Loan":
        navigate("/create-home-loan");
        break;
      case "Personal Loan":
        navigate("/create-personal-loan");
        break;
      case "Doctor Loan":
        navigate("/create-doctor-loan");
        break;
      case "Business Loan":
        navigate("/create-business-loan");
        break;
      case "Car Loan":
        navigate("/create-car-loan");
        break;
      case "Credit Card":
        navigate("/create-credit-card");
        break;
      case "Mortgage Loan":
        navigate("/create-mortgage-loan");
        break;
      case "Insurance":
        navigate("/create-insurance");
        break;
      default:
        break;
    }
    setDropdownVisible(false);
  };

  return (
    <div className="dashboard-content-container">
      <div className="dashboard-summary-container">
        <div className="summary-item-dashboard">
          <div className="header-dashboard">
            <h2>Approved</h2>
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="dash-icon-circle"
            />
          </div>
          <div className="content-dashboard">
            <p>
              <FaHome className="icon-type" />
              <span className="loan-name">Home Loan</span>
              <span className="list-count">{homeLoansApproved}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Personal Loan</span>
              <span className="list-count">{personalLoansApproved}</span>
            </p>
            <p>
              <FaBusinessTime className="icon-type" />
              <span className="loan-name">Business Loan</span>
              <span className="list-count">{businessLoansApproved}</span>
            </p>
            <p>
              <FaCar className="icon-type" />
              <span className="loan-name">Car Loan</span>
              <span className="list-count">{carLoansApproved}</span>
            </p>
            <p>
              <FaLandmark className="icon-type" />
              <span className="loan-name">Mortgage Loan</span>
              <span className="list-count">{mortgageLoansApproved}</span>
            </p>
            <p>
              <FaCreditCard className="icon-type" />
              <span className="loan-name">Credit Card</span>
              <span className="list-count">{creditCardLoansApproved}</span>
            </p>
            <p>
              <FaShieldAlt className="icon-type" />
              <span className="loan-name">Insurance</span>
              <span className="list-count">{insuranceLoansApproved}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Doctor Loan</span>
              <span className="list-count">{doctorLoansApproved}</span>
            </p>
          </div>
        </div>
        <div className="summary-item-dashboard">
          <div className="header-dashboard">
            <h2>In Process</h2>
            <FontAwesomeIcon icon={faSpinner} className="dash-icon-spinner" />
          </div>
          <div className="content-dashboard">
            <p>
              <FaHome className="icon-type" />
              <span className="loan-name">Home Loan</span>
              <span className="list-count">{homeLoansInProgress}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Personal Loan</span>
              <span className="list-count">{personalLoansInProgress}</span>
            </p>

            <p>
              <FaBusinessTime className="icon-type" />
              <span className="loan-name">Business Loan</span>
              <span className="list-count">{businessLoansInProgress}</span>
            </p>
            <p>
              <FaCar className="icon-type" />
              <span className="loan-name">Car Loan</span>
              <span className="list-count">{carLoansInProgress}</span>
            </p>
            <p>
              <FaLandmark className="icon-type" />
              <span className="loan-name">Mortgage Loan</span>
              <span className="list-count">{mortgageLoansInProgress}</span>
            </p>
            <p>
              <FaCreditCard className="icon-type" />
              <span className="loan-name">Credit Card</span>
              <span className="list-count">{creditCardLoansInProgress}</span>
            </p>
            <p>
              <FaShieldAlt className="icon-type" />
              <span className="loan-name">Insurance</span>
              <span className="list-count">{insuranceLoansInProgress}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Doctor Loan</span>
              <span className="list-count">{doctorLoansInProgress}</span>
            </p>
          </div>
        </div>

        <div className="summary-item-dashboard">
          <div className="header-dashboard">
            <h2>Rejected</h2>
            <FontAwesomeIcon icon={faTimesCircle} className="dash-icon-time" />
          </div>
          <div className="content-dashboard">
            <p>
              <FaHome className="icon-type" />
              <span className="loan-name">Home Loan</span>
              <span className="list-count">{homeLoansRejected}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Personal Loan</span>
              <span className="list-count">{personalLoansRejected}</span>
            </p>

            <p>
              <FaBusinessTime className="icon-type" />
              <span className="loan-name">Business Loan</span>
              <span className="list-count">{businessLoansRejected}</span>
            </p>
            <p>
              <FaCar className="icon-type" />
              <span className="loan-name">Car Loan</span>
              <span className="list-count">{carLoansRejected}</span>
            </p>
            <p>
              <FaLandmark className="icon-type" />
              <span className="loan-name">Mortgage Loan</span>
              <span className="list-count">{mortgageLoansRejected}</span>
            </p>
            <p>
              <FaCreditCard className="icon-type" />
              <span className="loan-name">Credit Card</span>
              <span className="list-count">{creditCardLoansRejected}</span>
            </p>
            <p>
              <FaShieldAlt className="icon-type" />
              <span className="loan-name">Insurance</span>
              <span className="list-count">{insuranceLoansRejected}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Doctor Loan</span>
              <span className="list-count">{doctorLoansRejected}</span>
            </p>
          </div>
        </div>
      </div>

      <div className="dashboard-summary-container">
        <div className="summary-item-dashboard">
          <div className="header-dashboard approve">
            <h2>Pending</h2>
            <FontAwesomeIcon
              icon={faHourglassHalf}
              className="dash-icon-hour"
            />
          </div>
          <div className="content-dashboard">
            <p>
              <FaHome className="icon-type" />
              <span className="loan-name">Home Loan</span>
              <span className="list-count">{homeLoans}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Personal Loan</span>
              <span className="list-count">{personalLoans}</span>
            </p>

            <p>
              <FaBusinessTime className="icon-type" />
              <span className="loan-name">Business Loan</span>
              <span className="list-count">{businessLoans}</span>
            </p>
            <p>
              <FaCar className="icon-type" />
              <span className="loan-name">Car Loan</span>
              <span className="list-count">{carLoans}</span>
            </p>
            <p>
              <FaLandmark className="icon-type" />
              <span className="loan-name">Mortgage Loan</span>
              <span className="list-count">{mortgageLoans}</span>
            </p>
            <p>
              <FaCreditCard className="icon-type" />
              <span className="loan-name">Credit Card</span>
              <span className="list-count">{creditCardLoans}</span>
            </p>
            <p>
              <FaShieldAlt className="icon-type" />
              <span className="loan-name">Insurance</span>
              <span className="list-count">{insuranceLoans}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Doctor Loan</span>
              <span className="list-count">{doctorLoans}</span>
            </p>
          </div>
        </div>
        <div className="summary-item-dashboard">
          <div className="header-dashboard">
            <h2>Open</h2>
            <FontAwesomeIcon icon={faEye} className="dash-icon-list" />
          </div>
          <div className="content-dashboard">
            <p>
              <FaHome className="icon-type" />
              <span className="loan-name">Home Loan</span>
              <span className="list-count">{homeLoansOpen}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Personal Loan</span>
              <span className="list-count">{personalLoansOpen}</span>
            </p>

            <p>
              <FaBusinessTime className="icon-type" />
              <span className="loan-name">Business Loan</span>
              <span className="list-count">{businessLoansOpen}</span>
            </p>
            <p>
              <FaCar className="icon-type" />
              <span className="loan-name">Car Loan</span>
              <span className="list-count">{carLoansOpen}</span>
            </p>
            <p>
              <FaLandmark className="icon-type" />
              <span className="loan-name">Mortgage Loan</span>
              <span className="list-count">{mortgageLoansOpen}</span>
            </p>
            <p>
              <FaCreditCard className="icon-type" />
              <span className="loan-name">Credit Card</span>
              <span className="list-count">{creditCardLoansOpen}</span>
            </p>
            <p>
              <FaShieldAlt className="icon-type" />
              <span className="loan-name">Insurance</span>
              <span className="list-count">{insuranceLoansOpen}</span>
            </p>
            <p>
              <FaUser className="icon-type" />
              <span className="loan-name">Doctor Loan</span>
              <span className="list-count">{doctorLoansOpen}</span>
            </p>
          </div>
        </div>
        <div className="summary-item-dashboard">
          <div className="header-dashboard">
            <h2>Total</h2>
            <FontAwesomeIcon icon={faDatabase} className="dash-icon-data" />
          </div>
          <div className="content-dashboard">
            <p>
              <FontAwesomeIcon icon={faEye} className="icon-type-eye" />
              <span className="loan-name">Open Loan</span>
              <span className="list-count">
                {homeLoansOpen +
                  personalLoansOpen +
                  doctorLoansOpen +
                  businessLoansOpen +
                  carLoansOpen +
                  mortgageLoansOpen +
                  creditCardLoansOpen +
                  insuranceLoansOpen}
              </span>
            </p>
            <p>
              <FontAwesomeIcon
                icon={faHourglassHalf}
                className="icon-type-hour"
              />
              <span className="loan-name">Pending Loan</span>
              <span className="list-count">
                {homeLoans +
                  personalLoans +
                  doctorLoans +
                  businessLoans +
                  carLoans +
                  mortgageLoans +
                  creditCardLoans +
                  insuranceLoans}
              </span>
            </p>
            <p>
              <FontAwesomeIcon icon={faSpinner} className="icon-type" />
              <span className="loan-name">In Progress Loan</span>
              <span className="list-count">
                {homeLoansInProgress +
                  personalLoansInProgress +
                  doctorLoansInProgress +
                  businessLoansInProgress +
                  carLoansInProgress +
                  mortgageLoansInProgress +
                  creditCardLoansInProgress +
                  insuranceLoansInProgress}
              </span>
            </p>
            <p>
              <FontAwesomeIcon icon={faCheckCircle} className="icon-type" />
              <span className="loan-name">Approved Loan</span>
              <span className="list-count">
                {homeLoansApproved +
                  personalLoansApproved +
                  doctorLoansApproved +
                  businessLoansApproved +
                  carLoansApproved +
                  mortgageLoansApproved +
                  creditCardLoansApproved +
                  insuranceLoansApproved}
              </span>
            </p>
            <p>
              <FontAwesomeIcon icon={faTimesCircle} className="icon-type" />
              <span className="loan-name">Rejected Loan</span>
              <span className="list-count">
                {homeLoansRejected +
                  personalLoansRejected +
                  doctorLoansRejected +
                  businessLoansRejected +
                  carLoansRejected +
                  mortgageLoansRejected +
                  creditCardLoansRejected +
                  insuranceLoansRejected}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="circle-button-container" ref={dropdownRef}>
        <button className="circular-button" onClick={handleButtonClick}>
          +
        </button>
        {isDropdownVisible && (
          <div className="dropdown-menu">
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Home Loan")}
            >
              Home Loan
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Personal Loan")}
            >
              Personal Loan
            </div>

            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Business Loan")}
            >
              Business Loan
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Car Loan")}
            >
              Car Loan
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Mortgage Loan")}
            >
              Mortgage Loan
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Credit Card")}
            >
              Credit Card
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Insurance")}
            >
              Insurance
            </div>
            <div
              className="dropdown-option"
              onClick={() => handleOptionClick("Doctor Loan")}
            >
              Doctor Loan
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardContent;
